import * as Yup from 'yup';

import i18n from '@/i18n';
import { CustomAttributeTemplate } from '@/types';

export const dynamicValidationSchema = (customAttributeTemplates: CustomAttributeTemplate[]) => {
  const schemaFields: Record<string, Yup.StringSchema> = {
    title: Yup.string().max(30, i18n.t('maxChar', { size: 30, ns: 'common' }))
  };

  customAttributeTemplates?.forEach((at) => {
    let fieldValidation = Yup.string().max(35, i18n.t('maxChar', { size: 35, ns: 'common' }));

    if (at.validationRegex) {
      fieldValidation = fieldValidation.test(
        'regex-test',
        i18n.t('invalidFormat', { ns: 'common' }),
        function (value) {
          const regex = new RegExp(at.validationRegex ?? '');
          return regex.test(value ?? '');
        }
      );
    }

    schemaFields[at.id] = fieldValidation;
  });

  return Yup.object().shape(schemaFields);
};
